import request from '@/utils/request'

export default {
    getSystems: async({ commit }, params) => {
        commit('SET_LOAD', true)

        let url

        switch (params.bonusSystem) {
            case 'cashbackPercent':
                url = '/cashback/list'
                break

            case 'count':
                url = '/time-limited-bonus/list'
                break

            case 'sum':
                url = '/reach-amount-bonus/list'
        }

        await request({
            method: 'get',
            url,
            params
        }).then(res => {
            if (res.data && res.data.systems) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total,
                    limit: res.data.limit
                })

                commit('SET_SYSTEMS', res.data.systems)
            }
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    }
}
